import { ServerRequest, ServerRequestAsync } from '../../utils/apiweb';
import { ALERT_TYPE, IDS, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { cloneEntityInit } from '../../utils/helpers';

// DTO inicial del alta (fuente única: lo usan la vista de detalle y el alta directa de la grilla)
const CEMENTERIO_ENTITY_INIT = {
    cementerio: {
        id: 0,
        idCuenta: 0,
        idEstadoCarga: 20,
        fechaCargaInicio: null,
        fechaCargaFin: null,
        idTipoPrestador: 0,
        idTipoConstruccionFuneraria: 0,
        fechaAlta: null,
        fechaBaja: null,
        fechaPresentacion: null,
        fechaVencimiento: null,
        digitoVerificador: '',
        fechaConcesion: null,
        fechaEscritura: null,
        fechaSucesion: null,
        libroEscritura: '',
        folioEscritura: '',
        numeroSucesion: '',
        superficie: 0,
        largo: 0,
        ancho: 0,
        idCementerioInstitucion: 0,
        ...Object.fromEntries(Array.from({length: 15}, (_, i) => [`ubicacionValor${i + 1}`, '']))
    },
    cuenta: {
        id: 0,
        numeroCuenta: '',
        numeroWeb: '',
        idEstadoCuenta: 1,
        idTipoTributo: 0,
        idTributo: 0,
        fechaAlta: null,
        fechaBaja: null
    },
    relacionesCuentas: [],
    archivos: [],
    observaciones: [],
    etiquetas: [],
    variablesCuenta: [],
    vinculosCementerio: [],
    zonasEntrega: [],
    controladoresCuentas: [],
    condicionesEspeciales: [],
    recargosDescuentos: [],
    debitosAutomaticos: [],
    inhumados: [],
    elementos: []
};

// Factory: cada consumidor recibe su propio clon, así nadie muta el DTO compartido
export const buildCementerioEntityInit = () => cloneEntityInit(CEMENTERIO_ENTITY_INIT);

export const UpdateEntityRow = (typeEntity, row, entity, countChangeInhumados, setCountChangeInhumados) => {
    // o:original a:add m:modify r:remove c:modify only childs

    if (typeEntity === 'RelacionCuenta') {
        if (row.state === 'a') {
            entity.relacionesCuentas.push(row);
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.relacionesCuentas = entity.relacionesCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.relacionesCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VariableCuenta') {
        if (row.state === 'a') {
            entity.variablesCuenta.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.variablesCuenta.indexOf(entity.variablesCuenta.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.variablesCuenta[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.variablesCuenta = entity.variablesCuenta.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.variablesCuenta.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'VinculoCementerio') {
        if (row.state === 'a') {
            entity.vinculosCementerio.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.vinculosCementerio.indexOf(entity.vinculosCementerio.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.vinculosCementerio[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.vinculosCementerio = entity.vinculosCementerio.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.vinculosCementerio.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ZonaEntrega') {
        if (row.state === 'a') {
            entity.zonasEntrega.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.zonasEntrega.indexOf(entity.zonasEntrega.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.zonasEntrega[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.zonasEntrega = entity.zonasEntrega.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.zonasEntrega.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }
    
    if (typeEntity === 'ControladorCuenta') {
        if (row.state === 'a') {
            entity.controladoresCuentas.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.controladoresCuentas.indexOf(entity.controladoresCuentas.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.controladoresCuentas[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.controladoresCuentas = entity.controladoresCuentas.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.controladoresCuentas.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'CondicionEspecial') {
        if (row.state === 'a') {
            entity.condicionesEspeciales.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.condicionesEspeciales.indexOf(entity.condicionesEspeciales.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.condicionesEspeciales[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.condicionesEspeciales = entity.condicionesEspeciales.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.condicionesEspeciales.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'RecargoDescuento') {
        if (row.state === 'a') {
            entity.recargosDescuentos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.recargosDescuentos.indexOf(entity.recargosDescuentos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.recargosDescuentos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.recargosDescuentos = entity.recargosDescuentos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.recargosDescuentos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'DebitosAutomaticos') {
        if (row.state === 'a') {
            entity.debitosAutomaticos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.debitosAutomaticos.indexOf(entity.debitosAutomaticos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.debitosAutomaticos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.debitosAutomaticos = entity.debitosAutomaticos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.debitosAutomaticos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Inhumado') {
        if (row.state === 'a') {
            entity.inhumados.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.inhumados.indexOf(entity.inhumados.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.inhumados[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.inhumados = entity.inhumados.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.inhumados.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
        setCountChangeInhumados(countChangeInhumados + 1);
    }
    
    if (typeEntity === 'Verificacion') {
        let inhumado = entity.inhumados.find(x => x.id === row.idInhumado);
        if (inhumado.state === 'o') {
            inhumado.state = 'c';
        }

        if (row.state === 'a') {
            inhumado.verificaciones.push(row);
        }
        else if (row.state === 'm') {
            const index = inhumado.verificaciones.indexOf(inhumado.verificaciones.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //sigue siendo un alta porque no existe en la bd
                inhumado.verificaciones[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                inhumado.verificaciones = inhumado.verificaciones.filter(f => f.id !== row.id);
            }
            else {
                let item = inhumado.verificaciones.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'Elemento') {
        if (row.state === 'a') {
            entity.elementos.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.elementos.indexOf(entity.elementos.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.elementos[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.elementos = entity.elementos.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.elementos.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }

    if (typeEntity === 'ElementoEntidad') {
        let elemento = entity.elementos.find(x => x.id === row.idElemento);
        if (elemento.state === 'o') {
            elemento.state = 'c';
        }

        if (row.state === 'a') {
            elemento.elementoEntidades.push(row);
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                elemento.elementoEntidades = elemento.elementoEntidades.filter(f => f.id !== row.id);
            }
            else {
                let item = elemento.elementoEntidades.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    }
}

export const FetchUbicacionDefinicion = async (idTipoConstruccionFuneraria) => {
    const paramsUrl = `/construccion/${idTipoConstruccionFuneraria}`;
    const response = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, APIS.URLS.CEMENTERIO_UBICACION_DEFINICION, paramsUrl);
    if (response.ok) {
        return await response.json();
    }
    throw new Error('Error al obtener definición de ubicación');
}

export const FindCementerio = (state, setState, callbackNoSuccess, callbackError, callbackSuccessFindCementerio) => {
    
    setState(prevState => {
    return {...prevState, loading: true};
    });

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.CEMENTERIO,
        paramsUrl,
        null,
        callbackSuccessFindCementerio,
        callbackNoSuccess,
        callbackError
    );

}

export const AddCementerio = (state, setState, cementerio_formValues, cuenta_formValues, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((row) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Cementerio ingresado correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                navigate({
                    to: `/cementerio/${OPERATION_MODE.EDIT}/${row.cementerio.id}`,
                    refresh: true,
                    replace: true,
                })
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const dataBody = {
        cementerio: {
            ...state.entity.cementerio,
            idEstadoCarga: cementerio_formValues.idEstadoCarga,
            idTipoPrestador: cementerio_formValues.idTipoPrestador
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: [],
        archivos: [],
        observaciones: [],
        etiquetas: [],
        variablesCuenta: [],
        vinculosCementerio: [],
        zonasEntrega: [],
        controladoresCuentas: [],
        condicionesEspeciales: [],
        recargosDescuentos: [],
        debitosAutomaticos: [],
        inhumados: [],
        elementos: []
    };

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.CEMENTERIO,
        null,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyCementerio = (state, setState, dataTagger, cementerio_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindCementerio, tipoConstruccionFuneraria) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Cementerio actualizado correctamente", () => {
            dispatch(dataTaggerActionClear(state.processKey));
            callbackSuccessFindCementerio(response);
        });
    };

    const dataBody = {
        cementerio: {
            ...state.entity.cementerio,
            idEstadoCarga: cementerio_formValues.idEstadoCarga,
            idTipoPrestador: cementerio_formValues.idTipoPrestador,
            idTipoConstruccionFuneraria: cementerio_formValues.idTipoConstruccionFuneraria,
            ...Object.fromEntries(
                Array.from({length: 15}, (_, i) => [
                    `ubicacionValor${i + 1}`,
                    tipoConstruccionFuneraria.tieneUbicacion ? cementerio_formValues[`ubicacionValor${i + 1}`] : ''
                ])
            ),
            fechaAlta: cementerio_formValues.fechaAlta,
            fechaBaja: cementerio_formValues.fechaBaja,
            fechaPresentacion: cementerio_formValues.fechaPresentacion,
            fechaVencimiento: cementerio_formValues.fechaVencimiento,
            digitoVerificador: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.digitoVerificador : '',
            fechaConcesion: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.fechaConcesion : null,
            fechaEscritura: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.fechaEscritura : null,
            fechaSucesion: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.fechaSucesion : null,
            libroEscritura: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.libroEscritura : '',
            folioEscritura: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.folioEscritura : '',
            numeroSucesion: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.numeroSucesion : '',
            superficie: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.superficie : 0,
            largo: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.largo : 0,
            ancho: (tipoConstruccionFuneraria.tieneSuperficie) ? cementerio_formValues.ancho : 0,
            idCementerioInstitucion: cementerio_formValues.idCementerioInstitucion,
        },
        cuenta: {
            ...state.entity.cuenta,
            numeroCuenta: cuenta_formValues.numeroCuenta,
            numeroWeb: cuenta_formValues.numeroWeb
        },
        relacionesCuentas: state.entity.relacionesCuentas.filter(f => f.state !== 'o'),
        archivos: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Archivo.filter(f => f.state !== 'o') : [],
        observaciones: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Observacion.filter(f => f.state !== 'o') : [],
        etiquetas: (dataTagger[state.processKey]) ? dataTagger[state.processKey].Etiqueta.filter(f => f.state !== 'o') : [],
        variablesCuenta: state.entity.variablesCuenta, //en este caso hacen falta todos para validar los rangos
        vinculosCementerio: state.entity.vinculosCementerio, //en este caso hacen falta todos para calcular el referente de la cuenta
        zonasEntrega: state.entity.zonasEntrega.filter(f => f.state !== 'o'),
        controladoresCuentas: state.entity.controladoresCuentas.filter(f => f.state !== 'o'),
        condicionesEspeciales: state.entity.condicionesEspeciales.filter(f => f.state !== 'o'),
        recargosDescuentos: state.entity.recargosDescuentos.filter(f => f.state !== 'o'),
        debitosAutomaticos: state.entity.debitosAutomaticos.filter(f => f.state !== 'o'),
        inhumados: state.entity.inhumados.filter(f => f.state !== 'o').map(x => {
            x.verificaciones = x.verificaciones.filter(f => f.state !== 'o');
            return x;
        }),
        elementos: state.entity.elementos.filter(f => f.state !== 'o')
    };

    const paramsUrl = `/${state.id}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.CEMENTERIO,
        paramsUrl,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const ModifyBajaCuenta = (idCuenta, state, setState, dispatch, navigate, dataTaggerActionClear, callbackNoSuccess, callbackError) => {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((row) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La cuenta fue dada de baja correctamente", () => {
                dispatch(dataTaggerActionClear(state.processKey));
                setState(prevState => {
                    return {...prevState, loading: false};
                });
                navigate({
                    to: `/cementerio/${OPERATION_MODE.VIEW}/${row.idTributo}`,
                    refresh: true,
                    replace: true,
                })
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = `/baja/${idCuenta}`;

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.CUENTA,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

}

export const MakeListDomicilios = async (state) => {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            if (state.entity.zonasEntrega.length > 0 && state.entity.cuenta.idDireccionEntrega) {
                let direccion = null;
                state.entity.zonasEntrega.forEach(x => {
                    if (x.direccion.id === state.entity.cuenta.idDireccionEntrega) {
                        direccion = x.direccion;
                    }
                });
                if (direccion) {
                    const domicilioEntrega = {...direccion, domicilio: "Entrega"};
                    listDomicilios.push(domicilioEntrega);
                }
            }

            const titular = state.entity.vinculosCementerio.find(vinculo => vinculo.idTipoVinculoCementerio === IDS.TIPO_VINCULO_CEMENTERIO.TITULAR)
            if (titular) {
                let direccion = null;

                const isPersonaFisica = (titular.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                const paramsUrl = `/${titular.idPersona}`;

                try {
                    const res = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                    if (res.ok) {
                        try {
                            const data = await res.json();
                            direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                        }
                        catch (error) {
                            reject(error);
                            return;
                        }
                    }
                    else {
                        reject(res);
                        return;
                    }
                }
                catch(error) {
                    reject(error);
                    return;
                }

                if (direccion) {
                    const domicilioTitular = {...direccion, domicilio: "Titular"};
                    listDomicilios.push(domicilioTitular);
                }
            }

            resolve(listDomicilios);
        }
        catch (error) {
            reject(error);
        }
    });
}


export function MakeListDomiciliosRelacionados(vinculosTributo) {
    return new Promise(async (resolve, reject) => {
        try {
            let listDomicilios = [];

            const promises = vinculosTributo.map(async (vinculo) => {
                if (vinculo.idTipoVinculoCementerio === IDS.TIPO_VINCULO_CEMENTERIO.TITULAR || 
                    vinculo.idTipoVinculoCementerio === IDS.TIPO_VINCULO_CEMENTERIO.RESPONSABLE_CUENTA) {
                    const isPersonaFisica = (vinculo.idTipoPersona === IDS.TIPO_PERSONA.FISICA);
                    const endpoint = isPersonaFisica ? APIS.URLS.PERSONA_FISICA : APIS.URLS.PERSONA_JURIDICA;
                    const paramsUrl = `/${vinculo.idPersona}`;

                    try {
                        const response = await ServerRequestAsync(REQUEST_METHOD.GET, null, true, endpoint, paramsUrl);
                        if (response.ok) {
                            const data = await response.json();
                            const direccion = isPersonaFisica ? data.direccion : data.domicilioLegal;
                            const tipoVinculo = vinculo.idTipoVinculoCementerio === IDS.TIPO_VINCULO_CEMENTERIO.TITULAR ? 'Titular' : "Responsable de cuenta";
                            const domicilio = { ...direccion, tipoVinculo: tipoVinculo, nombrePersona: vinculo.nombrePersona };
                            return domicilio;
                        }
                    } catch (error) {
                        reject(error);
                    }
                }
            });

            const results = await Promise.all(promises);

            results.forEach(domicilio => {
                if (domicilio) {
                    listDomicilios.push(domicilio);
                }
            });

            resolve(listDomicilios);
        } catch (error) {
            reject(error);
        }
    });
  }